export { BASIC_ITSM_TEMPLATE_ID as INCIDENT_TEMPLATE_ID } from '../jsm-use-case-template-choice/jsm-use-case-template-choice-constants';

export type JsmIncidentManagementIntent = {
	readonly source: 'selector';
	readonly cardKey: 'incident-management';
	readonly accountId: string;
	readonly signupId: string | undefined;
	readonly siteName: string;
};

export type JsmIncidentManagementSetupState = {
	readonly stage:
		| 'idle'
		| 'waiting-for-project'
		| 'checking-organization'
		| 'creating-team'
		| 'checking-membership'
		| 'checking-eligibility'
		| 'enabling'
		| 'polling'
		| 'complete'
		| 'error'
		| 'timeout';
	readonly teamId?: string;
	readonly asyncRequestId?: string;
};
